var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomersicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4286 4.42878C11.4286 6.79571 9.50979 8.7145 7.14286 8.7145C4.77593 8.7145 2.85714 6.79571 2.85714 4.42878C2.85714 2.06185 4.77593 0.143066 7.14286 0.143066C9.50979 0.143066 11.4286 2.06185 11.4286 4.42878ZM7.14286 10.143C3.19797 10.143 0 13.341 0 17.2859C0 17.6803 0.319797 18.0002 0.714286 18.0002H13.5714C13.9659 18.0002 14.2857 17.6803 14.2857 17.2859C14.2857 13.341 11.0877 10.143 7.14286 10.143ZM19.2859 18.0002H15.968C16.0354 17.7739 16.0716 17.534 16.0716 17.2859C16.0716 14.37 14.6739 11.7807 12.5119 10.1512C12.6263 10.1458 12.7415 10.143 12.8573 10.143C16.8021 10.143 20.0001 13.341 20.0001 17.2859C20.0001 17.6803 19.6803 18.0002 19.2859 18.0002ZM12.8573 8.7145C12.4262 8.7145 12.01 8.65085 11.6176 8.53247C12.6092 7.45185 13.2144 6.011 13.2144 4.42878C13.2144 2.84657 12.6092 1.40571 11.6176 0.325081C12.01 0.206695 12.4262 0.143066 12.8573 0.143066C15.2241 0.143066 17.143 2.06185 17.143 4.42878C17.143 6.79571 15.2241 8.7145 12.8573 8.7145Z",
    fill: "#B5B9BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersicon);
export default __webpack_public_path__ + "static/media/customersicon.bd2ec60f1589bf26214772ade6d19823.svg";
export { ForwardRef as ReactComponent };